import httpClient from '@api/httpClient'
import type { PaginatedResponse } from '@models/pagination'
import type { Trailer, TrailerFilters } from '@models/trailer'
import { trailersUrls } from './constants'

const getTrailers = async (filters: TrailerFilters) => {
  const { companyId, ...params } = filters
  const { data } = await httpClient.get<PaginatedResponse<Trailer>>(
    trailersUrls.root(companyId),
    { params: { ...params, companyId } },
  )
  return data
}

export interface CreateTrailerRequestData {
  companyId: number
  trailerExternalId: string
  plateNumber: string
  fuelTankCapacity: number
}

const createTrailer = async ({
  companyId,
  ...props
}: CreateTrailerRequestData) => {
  const { data } = await httpClient.post<Trailer>(
    trailersUrls.root(companyId),
    props,
  )
  return data
}

export interface UpdateTrailerRequestData {
  companyId: number
  id: number
  plateNumber: string
  fuelTankCapacity: number
}

const updateTrailer = async ({
  companyId,
  id,
  ...props
}: UpdateTrailerRequestData) => {
  const { data } = await httpClient.patch<Trailer>(
    trailersUrls.trailer(companyId, id),
    props,
  )
  return data
}

export interface DeleteTrailerRequestData {
  companyId: number
  id: number
}

const deleteTrailer = async ({ companyId, id }: DeleteTrailerRequestData) => {
  const { data } = await httpClient.delete(trailersUrls.trailer(companyId, id))
  return data
}

export default { getTrailers, createTrailer, updateTrailer, deleteTrailer }
